import React from "react";
import { Navigate } from "react-router-dom";

// Lazy load components for better performance
const Home = React.lazy(() => import("./pages/Home/Home"));
const About = React.lazy(() => import("./pages/About/About"));
const Contact = React.lazy(() => import("./pages/Contact/Contact"));
const DecorCardsPage = React.lazy(() =>
  import("./pages/DecorCardsPage/DecorCardsPage")
);
const DecorDetailsPage = React.lazy(() =>
  import("./pages/DecorDetailsPage/DecorDetailsPage")
);
const Login = React.lazy(() => import("./pages/Sign/Login"));
const Notification = React.lazy(() =>
  import("./pages/Notification/Notification")
);
const Wishlist = React.lazy(() => import("./pages/Wishlist/Wishlist"));
const Profile = React.lazy(() => import("./pages/Profile/Profile"));
const BookingOrders = React.lazy(() =>
  import("./pages/BookingOrders/BookingOrders")
);
const BookingOrdersDetails = React.lazy(() =>
  import("./pages/BookingOrderDetails/BookingOrdersDetails")
);
const Terms = React.lazy(() => import("./pages/Terms/Terms"));
const Policies = React.lazy(() => import("./pages/Policies/Policies"));
const Cart = React.lazy(() => import("./pages/Cart/Cart"));
const Checkout = React.lazy(() => import("./pages/Checkout/Checkout"));
const CancellationPolicy = React.lazy(() =>
  import("./pages/CancellationPolicy/CancellationPolicy")
);
const Support = React.lazy(() => import("./pages/Support/Support"));
const Register = React.lazy(() => import("./pages/Sign/Register"));
const Tickets = React.lazy(() => import("./pages/Tickets/Tickets"));

// Loading component for Suspense fallback
const Loading = () =>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "#f5f5f5"
    }}
  >
    <div>Loading...</div>
  </div>;

const routes = [
  {
    path: "/",
    element: <Navigate to="/home" replace />
  },
  {
    path: "/home",
    name: "Home",
    element: <Home />
  },
  {
    path: "/about",
    name: "About Us",
    element: <About />
  },
  {
    path: "/contact",
    name: "Contact",
    element: <Contact />
  },
  {
    path: "/decor-cards",
    name: "Decor Cards",
    element: <DecorCardsPage />
  },
  {
    path: "/decor-details/:id",
    name: "Decor Details",
    element: <DecorDetailsPage />
  },
  {
    path: "*",
    element: <Navigate to="/home" replace />
  },
  {
    path: "/login",
    name: "Log In",
    element: <Login />
  },
  {
    path: "/notifications",
    name: "Notifications",
    element: <Notification />
  },
  {
    path: "/wishlist",
    name: "Wishlist",
    element: <Wishlist />
  },
  {
    path: "/profile",
    name: "Profile",
    element: <Profile />
  },
  {
    path: "/booking-orders",
    name: "Booking Orders",
    element: <BookingOrders />
  },
  {
    path: "/booking-orders-details/:id",
    name: "Booking Order Details",
    element: <BookingOrdersDetails />
  },
  {
    path: "/terms",
    name: "Terms and Conditions",
    element: <Terms />
  },
  {
    path: "/policies",
    name: "Policies",
    element: <Policies />
  },
  {
    path: "/cart",
    name: "Cart",
    element: <Cart />
  },
  {
    path: "/checkout",
    name: "Checkout",
    element: <Checkout />
  },
  {
    path: "/cancellation-policy",
    name: " cancellation Policy",
    element: <CancellationPolicy />
  },
  {
    path: "/support",
    name: "Help and Support",
    element: <Support />
  },
  {
    path: "/register",
    name: "Register",
    element: <Register />
  },
  {
    path: "/tickets",
    name: "Tickets",
    element: <Tickets />
  }
];

export { routes, Loading };
